import { type PropsWithChildren, useEffect } from 'react'
import { configureAnalytics } from './index'
import { useAnalytics } from './hooks/index'

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    configureAnalytics()
  }, [])

  useAnalytics()

  return children as JSX.Element
}
